module.exports = __webpack_public_path__ + "img/ex-shower-on.58ce718d.png";